import { Extension } from "@tiptap/core"

export const ShiftEnterParagraph = Extension.create({
	name: "shiftEnterParagraph",

	priority: 1000,

	addKeyboardShortcuts() {
		return {
			"Shift-Enter": () => this.editor.commands.keyboardShortcut("Enter"),
		}
	},
})
